import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
} from '@angular/core';

import { SecurityScope } from '../../../auth/auth.model';
import { SearchUserDialog } from '../../../user/search-user.dialog';
import { User } from '../../../user/user.model';
import { Scorecard } from '../../scorecard-next.model';
import { PeriodType, PeriodTypeShallow } from '../../scorecard.model';
import { HistoryPositionNavigate } from '../general/history-position-navigate.model';
import { HistoryPosition } from '../general/history-position.model';
import { TranslationKeyMap } from '../pulse-widget.i18n';

@Component({
    selector: 'cmps-sw-detail',
    templateUrl: './pw-detail.component.html',
    host: {
        class: 'cmps-sw-detail',
    },
})
export class SwDetailComponent implements OnDestroy {
    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _periodTypes: any[];
    /** @private */ _selectedPeriodType: PeriodType;

    @Input() user: User;
    @Input() scorecard: Scorecard;
    @Input() historyPosition: HistoryPosition;
    // eslint-disable-next-line accessor-pairs
    @Input() set periodTypes(value: PeriodTypeShallow[]) {
        this._periodTypes = [];
        if (value) {
            value.forEach((p) => {
                this._periodTypes.push({
                    value: p.periodTypeId,
                    label: p.periodTypeName,
                    isDefault: p.periodTypeId === this.selectedPeriodType,
                });
            });
        }
    }

    // eslint-disable-next-line accessor-pairs
    @Input() set selectedPeriodType(value: PeriodType) {
        this._selectedPeriodType = value;
    }

    @Output() userSelect: EventEmitter<User>;
    @Output() navigate: EventEmitter<HistoryPositionNavigate>;
    @Output() onPeriodTypeChange: EventEmitter<string>;
    @Output() onPeriodTypeFocus: EventEmitter<void>;

    constructor(private readonly _userSearchDialog: SearchUserDialog) {
        this.userSelect = new EventEmitter();
        this.navigate = new EventEmitter();
        this.onPeriodTypeChange = new EventEmitter();
        this.onPeriodTypeFocus = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.userSelect.complete();
        this.navigate.complete();
        this.onPeriodTypeChange.complete();
        this.onPeriodTypeFocus.complete();
        this._userSearchDialog.closeAll();
    }

    /** @private */ _onSearchUserClick(): void {
        this._userSearchDialog.closeAll();
        this._userSearchDialog.openUsingNgbModal({
            userId: this.scorecard ? this.scorecard.header.userId : null,
            scope: SecurityScope.SCORECARD,
            close: (user) => {
                if (user) {
                    this.userSelect.emit(user.copy());
                }
            },
        });
    }

    /** @private */ _onPrevClick(): void {
        this.navigate.emit({ direction: -1 });
    }

    /** @private */ _onNextClick(): void {
        this.navigate.emit({ direction: 1 });
    }

    /** @private */ _onPeriodTypeFocus(): void {
        this.onPeriodTypeFocus.emit();
    }

    /** @private */ _onPeriodTypeChange(periodType: string): void {
        this.onPeriodTypeChange.emit(periodType);
    }
}
